import lang from '../../lib/language';

export const EPIC_MOVERS_SYMBOL_NAME_LIMIT = 20;
export const EPIC_MOVERS_ROW_COUNT = 4;
export const EPIC_MOVERS_TABLE_HEADERS = [
  lang.commonEpicMoversSymbolName(),
  lang.commonEpicMoversLastPriceChanges(),
];

export const EPIC_MOVERS_INTERNAL_ROW_ITEMS_COUNT = 3;
export const EPIC_MOVERS_INTERNAL_TABLE_HEADERS = [
  lang.headerAccountBreakdownSymbolName(),
  lang.commonChart(),
  lang.commonLastPrice(),
  lang.commonPercentChange(),
];
